export function setCookie(
  name: string,
  value: string,
  days: number = 30,
  expired: boolean = false
) {
  const attributes = [`path=/`, "SameSite=Lax"];

  
  if (expired) {
    attributes.push("expires=Thu, 01 Jan 1970 00:00:00 GMT");
  } else if (days > 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    attributes.push(`expires=${date.toUTCString()}`);
    attributes.push(`max-age=${days * 24 * 60 * 60}`);
  }

  // Add Secure attribute in production
  if (process.env.NODE_ENV === "production") {
    attributes.push("Secure");
  }

  // Check if in the browser
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    document.cookie = `${name}=${value || ""}; ${attributes.join("; ")}`;
  } 

  
}
